import { useEffect, useState } from "react";
import { ITabProps } from "../../component";

const ZFTabs = (props: ITabProps) => {
	const [activeTabState, updatedActiveTabState] = useState(
		props.activeTabIndex
	);

	useEffect(() => updatedActiveTabState(props.activeTabIndex), [
		props.activeTabIndex,
	]);

	const onTabChange = (i: number) => props.onTabChange(i);

	const updateActiveTab = (index: number) => {
		updatedActiveTabState(index);
		onTabChange(index);
	};

	return (
		<>
			{props.tabs.length > 1 && (
				<div className="align-item zf-text-font-size-s zf-text-color-black zf-text-font-weight-medium tabs__border tab-full-width zf-text-case-capitalize zf-margin-b-xxxl zf-padding-l-xl zf-padding-r-xl">
					{props.tabs.map((tab, index) => {
						return (
							<div
								key={tab.title + index}
								className={
									(activeTabState === index
										? "activeTab "
										: "") +
									"zf-padding-t-s zf-padding-b-s zf-padding-l-xs zf-padding-r-xs zf-margin-r-xxl-8 tab"
								}
								onClick={() => updateActiveTab(index)}
							>
								{tab.title}
							</div>
						);
					})}
				</div>
			)}
		</>
	);
};

export default ZFTabs;
